'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { IS_READ_ONLY_DEMO_DASHBOARD, DASHBOARD_LIMIT_EXCEEDED } from '../problems';
import { useDashboardCount } from '../../data/hooks/useDashboardCount';
import useDashboardLimit from '../../access/limits/hooks/useDashboardLimit';
import { useIsReadOnlyDemoDashboard } from '../../access/hooks/useIsReadOnlyDemoDashboard';
import { lockdownIsInEffect } from '../../lib/dashboardLogic';
import { DATA_FETCHING_ERROR_PROBLEM_AND_MESSAGE, LOADING_PROBLEM_AND_MESSAGE } from '../shared/dataProblemsAndMessages';
import { jsx as _jsx } from "react/jsx-runtime";
const useEmailDashboardProblem = ({
  isManageExistingEmail,
  dashboard
}) => {
  const isReadOnlyDemoDashboard = useIsReadOnlyDemoDashboard();
  const {
    data: dashboardCount,
    loading: dashboardCountLoading,
    error: dashboardCountError
  } = useDashboardCount();
  const dashboardLimit = useDashboardLimit();
  if (dashboardCountLoading) {
    return LOADING_PROBLEM_AND_MESSAGE;
  }
  if (dashboardCountError) {
    return DATA_FETCHING_ERROR_PROBLEM_AND_MESSAGE;
  }
  if (isReadOnlyDemoDashboard) {
    return {
      problem: IS_READ_ONLY_DEMO_DASHBOARD,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.emailReport.button.tooltip.isReadOnlyDemo"
      })
    };
  }
  if (lockdownIsInEffect(dashboard) && dashboardCount > dashboardLimit) {
    return {
      problem: DASHBOARD_LIMIT_EXCEEDED,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: isManageExistingEmail ? 'reporting-action-components.actions.manageRecurringEmails.button.tooltip.dashboardLimitExceeded' : 'reporting-action-components.actions.emailReport.button.tooltip.dashboardLimitExceeded',
        options: {
          limit: dashboardLimit
        }
      })
    };
  }
  return {
    problem: null,
    disabledMessage: null
  };
};
export default useEmailDashboardProblem;